module.exports = __webpack_public_path__ + "static/ft04-5aab3832411a774c657f3c6d51f52eee.jpg";